import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps, Skeleton, Tooltip } from '@mui/material';
import isEmpty from 'lodash/isEmpty';

import { UserAvatar } from '@attackiq/queries';

interface IAvatarProps extends MuiAvatarProps {
  userAvatar?: UserAvatar;
  isLoading?: boolean;
  userId?: string;
}

export const Avatar = ({ userAvatar, isLoading, ...props }: IAvatarProps) => {
  if (isLoading) {
    return (
      <Skeleton variant="circular" animation="wave">
        <MuiAvatar {...props} />
      </Skeleton>
    );
  }

  if (!userAvatar?.is_active) {
    return (
      <Tooltip title="User no longer active">
        <MuiAvatar {...props} />
      </Tooltip>
    );
  }

  const fullName = `${userAvatar?.first_name} ${userAvatar?.last_name}`;
  const initials = `${userAvatar?.first_name?.[0] || ''}${userAvatar?.last_name?.[0] || ''}`.toUpperCase();
  const srcSet = !isEmpty(userAvatar?.avatar)
    ? `${userAvatar?.avatar.thumbnail_50} 50w,
       ${userAvatar?.avatar.thumbnail_100} 100w,
       ${userAvatar?.avatar.thumbnail_200} 200w,
       ${userAvatar?.avatar.full_size} 450w`
    : undefined;

  return (
    <MuiAvatar
      src={userAvatar?.avatar.thumbnail_50}
      srcSet={srcSet}
      alt={fullName}
      data-testid={`${userAvatar?.id}-avatar`}
      {...props}
    >
      {initials}
    </MuiAvatar>
  );
};

export default Avatar;
